// extracted by mini-css-extract-plugin
export default {"line":"CollapseIcon_line__ETTSM"};